import React, {Component} from 'react';

export class HiddenField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
    };
  }

  componentDidMount() {
    if (!this.state.initialized) {
      this.props.handleChange(this.props.name, this.props.value);
      this.setState({initialized: true}, this.props.handleBlur());
    }
  }

  render() {
    return <React.Fragment />;
  }
}
